import React, { Component } from 'react';
import loadable from '@loadable/component';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import PropTypes from 'prop-types';
import { isEmpty } from '../../../util/isEmpty';
import ErrorBoundary from '../../../ErrorBoundary';
import LoadableSpin from '../../common/LoadableSpin';
import BlurCards from '../blurCards/BlurCards';
import { showBlurCards } from '../../../util/showBlurCards';

// code splitting
const MainResultCard = loadable(
  () => import('../finalResultCard/MainResultCard'),
  {
    fallback: <LoadableSpin />,
  }
);

/**
 * @component
 * @name MainResultCardComponent
 * @category Search Page
 * @subcategory Rate Card
 * @description It is the container which shows all rate cards.
 * <br> <br>
 * **Example**
 * ```js
 *   <MainResultCardComponent />
 * ```
 */
class MainResultCardComponent extends Component {
  componentDidMount = () => {};
x
  render() {
    const { seaFCLJSON, seaLCLJSON, airJSON, enableSearchBlurCards , originalRateData,final_view_after_submit} =
      this.props;

    const filteredFclArr = seaFCLJSON?.rates?.filteredJson || []; // Getting filtered FCL rates
    //console.log("----filteredFclArr----- :",filteredFclArr)
    // should show blur cards
    let showResultBlurCards = showBlurCards(seaFCLJSON, seaLCLJSON, airJSON);

    //enableSearchBlurCards to show blur cards or not,
    //it's set to true after each success search btn click
    //it's set to false after user email is successfully sent to endpoint
    if (showResultBlurCards) {
      showResultBlurCards = enableSearchBlurCards;
    }

    if (showResultBlurCards) {
      return <BlurCards />;
    }

    return (
        <>
          <ErrorBoundary>
            { 
              filteredFclArr.length > 0 ? (
                filteredFclArr.map((item) => (
                    !item.blockRoute && (
                        <MainResultCard key={item?.uuid || item.id} fclItem={item} />
                    )
                ))
              )
              :
              (
                !isEmpty(seaFCLJSON) &&
                seaFCLJSON.rates &&
                Array.isArray(seaFCLJSON.rates.fcl) &&
                seaFCLJSON.rates.fcl.length !== 0 &&
                seaFCLJSON.rates.fcl.map((item) => (
                    !item.blockRoute && (
                        <MainResultCard key={item?.uuid || item.id} fclItem={item} />
                    )
                ))
              )
            }
            {!isEmpty(seaLCLJSON) &&
                seaLCLJSON.rates &&
                Array.isArray(seaLCLJSON.rates.lcl) &&
                seaLCLJSON.rates.lcl.length !== 0 &&
                seaLCLJSON.rates.lcl.map((item) => (
                    <MainResultCard key={item?.uuid || item.id} lclItem={item} />
                ))}
            {!isEmpty(airJSON) &&
                airJSON.rates &&
                Array.isArray(airJSON.rates.air) &&
                airJSON.rates.air.length !== 0 &&
                airJSON.rates.air.map((item) => (
                    <MainResultCard key={item.id} airItem={item} />
                ))}
          </ErrorBoundary>
        </>
    );
  }
}

MainResultCardComponent.propTypes = {
  /**
   * Sea FCL rate json
   */
  seaFCLJSON: PropTypes.object,
  /**
   * Sea LCL rate json
   */
  seaLCLJSON: PropTypes.object,
  /**
   * AIR rate json
   */
  airJSON: PropTypes.object,

  /**
   * whether to show blur cards or not on search page.
   */
  enableSearchBlurCards: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    // config: state.config,
    seaFCLJSON: state.route.seaFCLJSON,
    seaLCLJSON: state.route.seaLCLJSON,
    airJSON: state.route.airJSON,
    final_view_after_submit:state.form.final_view_after_submit,
    originalRateData: state.route.originalRateData,


    // errorMessage: state.route.errorMessage,
    // loading: state.route.loading,
    // url: state.route.url,
    // showNoResultCard: state.code_config.showNoResultCard,
    // filterByCheaper: state.route.filterByCheaper,
    // userEmailBlurCards: state.cache.userEmailBlurCards,

    enableSearchBlurCards: state.code_config.enableSearchBlurCards,
    transactionType: state.code_config.transactionType,
    queryParams: state.route.queryParams,
  };
};

export default connect(mapStateToProps, actions)(MainResultCardComponent);
